<template>
	<h2 v-if="sectionSubtitle != null" class="section__subheading" v-html="sectionSubtitle" />
</template>

<script setup>
	import {useI18n} from '#imports'
	const { locale } = useI18n()
	import {computed} from "vue";
	let sectionSubtitle
	const props = defineProps({
		content: Object
	})
	if(props.content) {
		sectionSubtitle = computed(() => locale.value === 'en' ? props.content.en : props.content.jp);
	}
</script>

<style lang="scss" scoped>
@use '@/assets/sass/variables.scss' as v;
.section__subheading {
	font-size: v.$font-size-med;
	line-height: v.$font-size-med * 1.25;
	margin: 0 0 1rem 0;
	@include v.respond-to('small') {
		font-size: v.$font-size-med;
		line-height: v.$font-size-med * 1.25;
		margin: 0 0 2rem 0;
	}
}
</style>


